import { createContext } from "react";

export interface PageContextType {
  hasSubHeader: boolean;
}

export const PageContext = createContext<PageContextType>({
  hasSubHeader: false,
});
